import axios, {AxiosRequestConfig} from 'axios';

class AxiosWrapper {
    static get(url: string, config?: AxiosRequestConfig) {
        return axios.get(url, config);
    }

    static post(url: string, data: any, config?: AxiosRequestConfig) {
        return config ? axios.post(url, data, config) : axios.post(url, data);
    }

    static put(url: string, data: any, config?: AxiosRequestConfig) {
        return config ? axios.put(url, data, config) : axios.put(url, data);
    }

    static delete(url: string, config?: AxiosRequestConfig) {
        return config ? axios.delete(url, config) : axios.delete(url);
    }
}

export default AxiosWrapper;
